// extracted by mini-css-extract-plugin
export default {"AboutTitle":"AboutModal_AboutTitle__lg-Kb","Content":"AboutModal_Content__iYlGx"};